module.exports = __webpack_public_path__ + "static/media/devops.9f1cd351.svg";